import '../utils';
import {showWarning} from "../utils";
import {FilterTypes} from "../../../control_produccion/components/FilterTypes";

export default {
    orderReferences: state => state.orderReferences,
    orderReferenceById: state => id => state.orderReferences.find(l => l.id === id),
    orderReferencesByStateId: state => orderStateId => {
        if(isNaN(orderStateId))
            return showWarning('Id de estado no valido', orderStateId)
        //En cola
        //
        let orders = [];
        // if(orderStateId === 3) orders = state.orderReferences
        // else orders = []


        if(orderStateId === 3) orders = state.orderReferences.filter(l => (l.state_id === orderStateId) && l.in_queue_date)
        else orders = state.orderReferences.filter(l => l.state_id === orderStateId)
        return orders??[];
    },
    orderReferencesByStateIdAndProductionLineId: (state,getters) => (orderStateId,productionLineId) => {
        if(isNaN(orderStateId) || isNaN(productionLineId))
            showWarning('Id de estado o linea de produccion no valido', orderStateId, productionLineId)

        let orders = getters.orderReferencesByStateId(orderStateId);
        orders = orders.filter(o => o.production_line_id == productionLineId)
        return orders??[];
    },
    orderStates: state => state.orderStates,

    histories: state => state.histories,
    historyByOrderReferenceId: state => id  => state.histories.find(h => h.order_reference_id === id ),

    activeModals: state => state.activeModals,
    activeModalByModalName: state => modalName => state.activeModals.find(m => m.modal === modalName),

    // Kanban
    kanban: state => state.kanban,
    kanbanOrderReferences: state => {
        return state.kanban.map(pl => ({
            orderReferencesPending:     state.kanban.map(pl => (pl.orderReferencesPending)).flat(),      // Pendiente
            orderReferencesQueued:      pl.orderReferencesQueued,           // En Cola - Ordenar al recoger los datos desde GET KANBAN
            orderReferenceInProduction: pl.orderReferenceInProduction,      // En Produccion
            orderReferencesFinished:    pl.orderReferencesFinished          // Finalizadas
        }));
    },
    kanbanOrderReferencesByStateId: state => stateId => {

        // En Ajos las ordenes pendientes no se diferencian por lineas, asi que hay que juntarlas aunque tengan una linea especificada

        return state.kanban.map(pl => ([
            ...(stateId == 1 ? state.kanban.map(pl => (pl.orderReferencesPending)).flat() : []),
            ...(stateId == 2 && pl.orderReferenceInProduction ? [pl.orderReferenceInProduction] : []),
            ...(stateId == 3 ? pl.orderReferencesFinished : []),
        ]));
    },
    kanbanOrderReferencesInQueueByProductionLineId: state => productionLineId => {
        var productionLine = state.kanban.find(pl => pl.id == productionLineId);

        if(!productionLine) {
            showWarning(`Linea de produccion no encontrada (id ${productionLineId})`)
            return [];
        }

        return productionLine.orderReferencesQueued;
    },
    kanbanOrderReferencesByStateIdAndProductionLineId: state => (stateId, productionLineId) => {
        var productionLine = state.kanban.find(pl => pl.id == productionLineId);

        if(!productionLine) {
            showWarning(`Datos de la linea de produccion no encontradaos (id ${productionLineId})`)
            return [];
        }

        let orderReferences = [];
        switch (stateId) {
            case 1: orderReferences = state.kanban.map(pl => (pl.orderReferencesPending ?? [])).flat() ; break;
            case 2: orderReferences = productionLine.orderReferenceInProduction ? [productionLine.orderReferenceInProduction] : []; break;
            case 3: orderReferences = productionLine.orderReferencesFinished ?? []; break;
        }

        return orderReferences;
    },
    kanbanErrorByProductionLineId: state => productionLineId => {
        var productionLine = state.kanban.find(pl => pl.id == productionLineId);

        if(!productionLine) return showWarning(`Linea de produccion no encontrada (id ${productionLineId})`)

        return (productionLine.hasOwnProperty('error'))? productionLine.error: null;
    },
    kanbanAlarmByProductionLineId: state => productionLineId => {
        var productionLine = state.kanban.find(pl => pl.id == productionLineId);

        if(!productionLine) return showWarning(`Linea de produccion no encontrada (id ${productionLineId})`)
        if(!productionLine.hasOwnProperty('orderReferenceInProduction') ) return showWarning(`Orden en produccion no encontrada para la linea de produccion (id ${productionLineId})`)

        let orderReferenceInProduction = productionLine.orderReferenceInProduction;

        return (orderReferenceInProduction && orderReferenceInProduction.hasOwnProperty('alarm'))? orderReferenceInProduction.alarm: null;
    },

    kanbanPendingOrderReferences: state => state.kanbanPendingOrderReferences,
    kanbanPendingOrderReferencesById: state => id => state.kanbanPendingOrderReferences.find(o => o.id == id),

    // Calendar

    calendarEvents: state => state.calendarEvents,
    calendarEventById: state => eventId => {
        return state.calendarEvents.find(e => e.id == eventId);
    },
    filters: state => {
        let filters = []
        Object.values(FilterTypes ).forEach(function(filter){
            filters.push(state[filter])
        })
        return filters;
    },
    filterByName: state => name =>  state.hasOwnProperty(name)? state[name]: null,

    // LAST UPDATE TIME
    lastUpdateTime: state => state.lastUpdateTime,
    queueEditActive: state => state.queueEditActive,

    showKanbanContainerOverlay: state => state.showKanbanContainerOverlay,

    isMenuShowing: state => state.isMenuShowing,
}
